export const iconFontAwesomeEducationBell = (
	<i className="fa-solid fa-bell"></i>
);
